<template>
  <div class="garden__content">
    <garden-plant-options :mode="mode"
                          :plant="plant"
                          :selected-map-plants-ids="selectedMapPlantsIds"
                          class="garden__content__options"
                          @changeMode="handleModeChange"
                          @changePlant="handlePlantChange"
                          @trashSelection="trashSelection" />
    <div id="map" class="garden__content__map map" />
  </div>
</template>

<script>
import GardenMap from '../../classes/GardenMap'
import GardenPlantOptions from '@/components/garden/PlantOptions'

export default {
  name: 'Map',
  components: { GardenPlantOptions },
  props: {
    visibleLayers: { type: Array, required: true },
  },
  data () {
    return {
      mode: 'Point',
      plant: null,
      selectedMapPlantsIds: [],
      gardenMap: null,
    }
  },
  methods: {
    setDrawTool () {
      if (!this.plant) return

      const plant = this.$store.getters.plant(this.plant)
      if (!plant) throw new Error(`Plant not found with id ${this.plant}`)

      this.gardenMap.draw(this.mode, plant)
    },
    handleModeChange (mode) {
      this.mode = mode
      switch (mode) {
        case 'Select':
          this.gardenMap.edit()
          break
        default:
          this.setDrawTool()
      }
    },
    handlePlantChange (plant) {
      this.plant = plant
      this.setDrawTool()
    },
    handleAddPlant (event) {
      const payload = {
        mapId: this.currentMap,
        plantId: event.detail.plantId,
        geoJson: event.detail.geoJSON,
      }
      this.$store.dispatch('addMapPlant', payload)
        .then((mapPlant) => { this.gardenMap.validateNewPlant(mapPlant, event.detail.feature) })
        .catch((error) => { console.error('HandleAddPlant', error) })
    },
    handleRemovePlant (event) {
      this.store.dispatch('destroyMapPlant', event.detail.id)
        .catch((error) => { console.error('handleRemovePlant', error) })
    },
    handleUpdatePlant (event) {
      const payload = {
        id: event.detail.id,
        geoJson: event.detail.geoJSON,
      }
      this.$store.dispatch('updateMapPlant', payload)
        // No need to update anything else for now.
        .catch((error) => { console.error('HandleAddPlant', error) })
    },
    handleSelection (event) {
      this.selectedMapPlantsIds = event.detail
    },
    trashSelection () {
      const ids = this.gardenMap.trashSelection()

      for (const id of ids) {
        this.$store.dispatch('deleteMapPlant', id)
          .catch((error) => { console.error(`trashSelection (${id})`, error) })
      }
    },
    createMap () {
      // Everything has been loaded in _Layout.vue
      this.$nextTick(() => {
        const layers = this.$store.getters.layers
        const mapId = parseInt(this.$route.params.mapId, 10)
        const mapConfig = this.$store.getters.map(mapId)
        this.gardenMap = new GardenMap(mapConfig, layers, 'map')
        GardenMap.preloadPatterns(this.$store.getters.plants)
          .then(() => {
            const mapPlants = this.$store.getters.mapPlants.filter(mp => mp.mapId === mapId)
            for (const mapPlant of mapPlants) {
              const plant = this.$store.getters.plant(mapPlant.plantId)
              this.gardenMap.addPlant(plant, mapPlant)
            }
          })
          .catch((error) => console.error('PreloadPatterns:', error))

        this.setDrawTool()

        this.gardenMap.mapElement.addEventListener('addplant', this.handleAddPlant)
        this.gardenMap.mapElement.addEventListener('updateplant', this.handleUpdatePlant)
        this.gardenMap.mapElement.addEventListener('select', this.handleSelection)

        // For debug only
        // this.gardenMap.debugLayers()
      })
    },
    destroyMap () {
      if (!this.gardenMap) return

      this.gardenMap.destroy()
      this.gardenMap = null
    },
  },
  created () {
    this.createMap()
  },
  beforeDestroy () {
    this.destroyMap()
  },
  // watch: {
  //   currentMap (newId) {
  //     console.log({ newId })
  //     if (!newId) throw new Error('No map ID provided!')
  //
  //     this.createMap()
  //   },
  // },
}
</script>
